import { useNotifications } from 'features/forecastNotifications/useNotifications'
import { useCallback, useRef } from 'react'
import {
  SEARCH_PARAM_THREAD,
  SEARCH_PARAM_TICKET,
} from 'routes/libra/-searchParams'

// Comment notifications encode their target only in cta.url query params
// (createCommentNotifications.ts → buildTicketUrl). No comment id → per-thread.
export const parseCommentTarget = (url: string | undefined) => {
  if (!url) return {}
  const q = url.indexOf('?')
  if (q === -1) return {}
  const params = new URLSearchParams(url.slice(q + 1))
  return {
    ticket: params.get(SEARCH_PARAM_TICKET) ?? undefined,
    thread: params.get(SEARCH_PARAM_THREAD) ?? undefined,
  }
}

export const useMarkThreadNotificationsRead = ({
  ticketId,
}: {
  ticketId: string
}) => {
  // enabled:false → no list/count subscription on the Libra page; markReadWhere
  // works regardless (it uses axios/buildUrl directly + global mutate).
  const { markReadWhere } = useNotifications({ enabled: false })

  // Dedupe rapid repeat clicks (expand↔collapse) so a thread isn't scanned twice
  // concurrently.
  const inFlight = useRef<Set<string>>(new Set())

  return useCallback(
    (threadId: string) => {
      if (inFlight.current.has(threadId)) return
      inFlight.current.add(threadId)
      void markReadWhere((n) => {
        const { ticket, thread } = parseCommentTarget(n.cta?.url)
        return ticket === ticketId && thread === threadId
      })
        .catch((err) =>
          console.error('Failed to mark comment notifications as read:', err)
        )
        .finally(() => inFlight.current.delete(threadId))
    },
    [markReadWhere, ticketId]
  )
}
